<template>
	<div class="bg-container">
		<div class="button">
			<el-button size="medium" v-if="activeValue > 1 && activeValue < 6" @click="toPrev"
				>上一步</el-button
			>
			<el-button type="primary" size="medium" @click="toNext" v-if="activeValue < 6"
				>确定，下一步</el-button
			>
			<!-- <el-button type="primary" size="medium" v-if="activeValue == 6" @click="onlineconfirm"
				>确认上线方案</el-button
			> -->
			<el-button
				type="primary"
				size="medium"
				v-if="activeValue == 6"
				@click="confirm('将提醒客户查看，是否确认？', sendCust)"
				>确认发送客户</el-button
			>
			<!-- <el-button
				type="primary"
				size="medium"
				v-if="activeValue == 6 && updateFlag == 1"
				@click="confirm('仅保存方案，方便后续修改，不会提醒客户', updatenotice)"
				>更新方案</el-button
			> -->
			<el-button
				type="primary"
				size="medium"
				v-if="queryParam.automationStatus >= 2 && activeValue < 6"
				@click="conserve"
				>保存查看方案</el-button
			>
		</div>
	</div>
</template>

<script>
import vm from '@/common/confirm.js';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: {
		activeValue: {
			default: 0,
		},
	},
	data() {
		return {
			updateFlag: 0,
		};
	},
	components: {},

	computed: {
		queryParam() {
			return this.$route.query;
		},
		id(){
			return this.$route.query.id;
		}
	},
	mounted() {
		this.getstepstatus();
	},
	methods: {
		toNext() {
			this.$emit('toNext');
		},
		toPrev() {
			this.$emit('toPrev');
		},
		conserve() {
			//跳转到最后一步
			this.$emit('toSkip');
			// this.$emit('toSkip', 6);
		},
		async onlineconfirm() {
			let res = await adsNewOnline.onlineconfirm({ id: this.id });
			console.log('确定上线方案', res.data);
			if (res.data == 'success') {
				vm._success('操作成功');
			}
		},
		//更新方案通知
		async updatenotice() {
			let res = await adsNewOnline.updatenotice({ id:  this.id });
			console.log('更新方案通知', res.data);

			if (res.data == 'success') {
				vm._success('更新成功');
			}
		},
		async sendCust() {
			let res = await adsNewOnline.customerconfirm({ id:  this.id });
			if (res.data == 'success') {
				vm._success('发送成功');
				this.$router.push({ name: 'adsTabPage' });
			}
		},
		confirm(message, cb) {
			this.$msgbox({
				title: '提示',
				message: message,
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				callback: (action, instance) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = '执行中...';
						cb();
						instance.confirmButtonLoading = false;
					} else {
						instance.confirmButtonLoading = false;
					}
				},
			}).then(action => {
				this.$message({
					type: 'info',
					message: 'action: ' + action,
				});
			});
		},
		async getstepstatus() {
			let res = await adsNewOnline.getstepstatus({ id: this.queryParam.id });
			this.updateFlag = res.data.updateFlag;
		},
	},
};
</script>

<style lang="scss" scoped>
.bg-container {
	height: 70px;
	background: #ffffff;
	display: flex;
	justify-content: flex-end;
	/* margin: 10px 0px; */
	align-items: center;
	position: absolute;
	bottom: 0;
	left: 240px;
	right: 26px;
	margin: 0;
	box-shadow: 0px -4px 4px 0px rgba(51, 51, 51, 0.05);
	border-radius: 4px;
	// border: 1px red solid;
	.button {
		padding-right: 50px;
	}
}
</style>
